import { render } from "./TestimonialsPage.vue?vue&type=template&id=0934bc1e"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js"

import "./TestimonialsPage.vue?vue&type=style&index=0&id=0934bc1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__